import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { AllRoleDetailsQuery } from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function RoleListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  const [roleData, setRoleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  //UseEffect for Fetching Function
  useEffect(() => {
    fetchRoleData();
    setStatus(false);
  }, [id, status]);

  //Table Mapping
  const roleListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S No",
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Role Name",
        field: "role",
        name: "Role Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: roleData.reverse().map((val, index) => ({
      sno: index + 1,
      id: val.id,
      role: val.role,
      createdBy: val?.user?.username,
    })),
  };

  //Fetch Table Data
  const fetchRoleData = () => {
    setIsLoading(true);
    request(BASEURL, AllRoleDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setRoleData(res.allRoleDetail);
      })
      .catch((err) => {
        console.error(err.message);
        setRoleData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Add Role
  const handleNewRole = () => {
    navigate("/role/add-role");
  };

  //Row Click
  const onRoleListClick = (e) => {
    if (e?.id) {
      navigate(`/role/add-role?${e?.id}`);
    }
  };

  const onDelete=(id)=>
  {
    console.log("id-d",id)
  }
      
  const onCheck=(list)=>
  {
    console.log("id-c",list)
  }
    
  const onDeleteALL=()=>
  {
    console.log("id-DELE")
  }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={roleListTable.columns}
      rowsData={roleListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Role List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onRoleListClick}
      onDelete={onDelete}
      onView={onRoleListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewRole()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Role List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewRole()}
              >
                Add Role
              </MaterialButton>
            </Stack>
          }
        />
       { !isLoading && 
       <MaterialDataGrid
          rows={roleListTable.rows}
          columns={roleListTable.columns}
          isSelectable={false}
          onRowClick={onRoleListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Role found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Role details. Click on the "Add Role"
                  button to start adding Role details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        /> }
             {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
